import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Zone } from '../interfaces/Zone';
import { UserData } from '../interfaces/UserData';
import { AuthService } from '../../shared/auth.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-zone5',
    templateUrl: './zone5.component.html',
    styleUrls: ['./zone5.component.scss'],
    standalone: false
})
export class Zone5Component implements OnInit, OnDestroy, AfterViewInit {
    activeContinent: number;
    public zones: Array<Zone>;

    public activeZone = 1;
    user: UserData;
    openZones: number;
    continent: number;
    tick2Quiz: boolean = true;
    quizLevel = -1;
    plane: any = {
        position: 1
    };

    levels = [];

    loading = true;
    adminUserData;

    constructor(private router: Router, private auth: AuthService) {
        this.zones = [
            {
                number: 17,
                class: 'turkey',
                id: '2-1-1',
                hover: false,
                active: false,
                locked: true
            },
            {
                number: 18,
                class: 'greece',
                id: '2-1-2',
                hover: false,
                active: false,
                locked: true
            },
            {
                number: 19,
                class: 'italy',
                id: '2-1-3',
                hover: false,
                active: false,
                locked: true
            },
            {
                number: 20,
                class: 'bosnia',
                id: '2-1-4',
                hover: false,
                locked: true,
                active: false
            }
        ];
    }
    ngOnInit() {
        this.tick2Quiz = true;
        this.userSubscription = this.auth.onUserUpdate.subscribe(userData => {
            if (userData != null && userData) this.loadChildData(userData);
        }, error => {
            console.log('error', error);
        });
    }
    userSubscription: Subscription;

    ngOnDestroy() {
        this.userSubscription.unsubscribe();
    }

    loadChildData(userData) {
        this.zones = [
            {
                number: 17,
                class: 'turkey',
                id: '2-1-1',
                hover: false,
                active: false,
                locked: true
            },
            {
                number: 18,
                class: 'greece',
                id: '2-1-2',
                hover: false,
                active: false,
                locked: true
            },
            {
                number: 19,
                class: 'italy',
                id: '2-1-3',
                hover: false,
                active: false,
                locked: true
            },
            {
                number: 20,
                class: 'bosnia',
                id: '2-1-4',
                hover: false,
                locked: true,
                active: false
            }
        ];
        this.user = userData;
        if (this.user.activities["2-2-1"]) {
            this.tick2Quiz = false;
        }
        this.adminUserData = JSON.parse(localStorage.getItem('quranera_admin_userData'));
        if (!userData) {
            if (this.adminUserData) {
                userData = this.adminUserData;
                userData.activeLevel = '9-9-9';
            }
        }
        this.openZones = userData.zone1Lvl;
        this.plane.position = this.openZones;
        this.levels = userData.activeLevel.split('-');
        this.activeZone = this.adminUserData ? 99 : parseInt(userData.activeLevel.split('-')[1], 10);
        this.activeContinent = parseInt(userData.activeLevel.split('-')[0], 10);
        if (this.activeZone > 1) {
            this.openZones = 5;
        } else {
            this.openZones = parseInt(userData.activeLevel.split('-')[2], 10);
        }

        this.continent = parseInt(userData.continentsLvl, 10);

        if (userData.quizLevel) {
            this.quizLevel = userData.quizLevel;
        }

        if (this.adminUserData) {
            this.quizLevel = 100;
        }

        this.zones.map((zone: Zone, i) => {
            this.zones[i].locked = this.adminUserData ? false : !(this.user.activities[zone.id]);
            this.zones[i].active = this.adminUserData ? false : (this.user.activeLevel === zone.id && this.user.activities[zone.id]);
        });
    }

    goQuiz() {
        if (this.quizLevel >= 5) {
            this.router.navigate(['/game/quiz-activity/2-1']);
        }
    }

    mouseEnter(zone) {
        const audio = document.getElementById('continentHover') as HTMLAudioElement;
        audio.pause();
        audio.currentTime = 0;
        if (audio) audio.play();
        this.zones[zone].hover = true;
    }

    mouseLeave(zone) {
        this.zones[zone].hover = false;
    }

    selectZone(zone) {
        if (!zone.locked) {
            const audio = document.getElementById('continentClick') as HTMLAudioElement;
            if (audio) audio.play();
            setTimeout(() => {
                this.router.navigate([`/game/activity-list/${zone.id}`]);
            }, 1000);
        }
    }

    playBgAudio() {
        let audio = <HTMLAudioElement>document.getElementById('bgAudio');
        if (audio) audio.play();
    }

    playIntroductionAudio() {
        let audio = <HTMLAudioElement>document.getElementById('introductionAudio');
        if (audio) audio.play();
    }

    instructionLoaded() {
        if (this.loading) {
            this.loading = false;
            let audio = <HTMLAudioElement>document.getElementById('introductionAudio');
            if (audio) audio.play();
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.loading) {
                this.instructionLoaded();
            }
        }, 2000);
    }

    haveAccess(activityLevel) {
        if (this.adminUserData) return true;

        if (this.user == undefined) return false;
        if (!this.user['activities'][activityLevel + '-1']
            && !this.user['activities'][activityLevel + '-2']
            && !this.user['activities'][activityLevel + '-3']
            && !this.user['activities'][activityLevel + '-4']
        ) return false;

        for (var a = 1; a <= 4; a++) {
            for (var i = 1; i <= 15; i++) {
                if (this.user["activities"][activityLevel + '-' + a.toString()]) {
                    if (this.user["activities"][activityLevel + '-' + a.toString()][i.toString()]) return true;
                }
            }
        }

        return false;
    }
}
